<style scoped="scoped" lang="scss">
._form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 120px;
}
</style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getKey="rows" getUrl="/web/config/excel/import/template/page" :columns="columns" @expandChange="expandChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mubankey')">
            <el-input v-model="yt.conditions.templateKey"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button> </el-form-item
        ></el-form>
      </template>

      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, '900px')" type="primary" v-if="ids == null">
          {{ $t('xinzeng') }}
        </el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, '900px', beforeShow)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/config/excel/import/template/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" dialog-scroller>
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form ref="form" size="mini" label-width="auto">
            <el-row :gutter="15">
              <el-col :span="12">
                <el-form-item :label="$t('mubankey')" required>
                  <el-input v-model="templateConfig.templateKey"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('beizhu')" required>
                  <el-input v-model="templateConfig.remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="15">
              <el-col :span="12">
                <el-form-item :label="$t('wenjiankey')">
                  <el-input v-model="templateConfig.fileKey"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider content-position="left"><span style="font-size: 12px;color: grey;">模板配置</span></el-divider>
            <el-row :gutter="15" v-for="(item, index) in templateConfig.templateValue" :key="index">
              <el-col :span="0.1">
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('title')" labelwidth="75px">
                  <el-input v-model="item.title"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('参数名')"> <el-input v-model="item.param"></el-input> </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('leixing')">
                  <el-select v-model="item.type" :placeholder="$t('qingxuanze')">
                    <el-option label="String" value="String"></el-option>
                    <el-option label="Float" value="Float"></el-option>
                    <el-option label="Int" value="Int"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
              {{ $t('tianjiapeizhi') }}
            </el-button>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer" style="margin-bottom: 20px;">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" type="primary" @click="saveConfig">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form ref="form" size="mini" label-width="auto">
            <el-row :gutter="15">
              <el-col :span="12">
                <el-form-item :label="$t('mubankey')" required>
                  <el-input v-model="templateConfig.templateKey"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('beizhu')" required>
                  <el-input v-model="templateConfig.remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="15">
              <el-col :span="12">
                <el-form-item :label="$t('wenjiankey')">
                  <el-input v-model="templateConfig.fileKey"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider content-position="left"
              ><span style="font-size: 12px;color: grey;"> {{ $t('mubanpeizhi') }}</span></el-divider
            >
            <el-row :gutter="15" v-for="(item, index) in templateConfig.templateValue" :key="index">
              <el-col :span="0.1">
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('title')">
                  <el-input v-model="item.title"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('参数名')"> <el-input v-model="item.param"></el-input> </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('类型')">
                  <el-select v-model="item.type" placeholder="请选择">
                    <el-option label="String" value="String"></el-option>
                    <el-option label="Float" value="Float"></el-option>
                    <el-option label="Int" value="Int"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
              {{ $t('tianjiapeizhi') }}
            </el-button>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" type="primary" @click="update">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'admin_data_template_excel_import_template',
  data() {
    return {
      columns: [
        {
          label: 'createTime',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'mubankey',
          prop: 'templateKey'
        },
        {
          label: 'wenjiankey',
          prop: 'fileKey'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          fixed: 'right'
        }
      ],
      initTempletConfig: {
        templateKey: null,
        remark: null,
        fileKey: null,
        templateValue: []
      },
      templateConfig: {
        templateKey: null,
        remark: null,
        fileKey: null,
        templateValue: []
      }
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    addItem() {
      this.templateConfig.templateValue.push({
        title: '',
        param: '',
        type: ''
      });
    },
    deleteItem(key) {
      this.templateConfig.templateValue = this.templateConfig.templateValue.filter((item, index) => {
        return index !== key;
      });
    },

    saveConfig() {
      if (this.templateConfig.templateValue.length === 0) {
        this.$message.error(this.$t('mubanpeizhibunengweikong'));
        return;
      }
      this.http
        .post('/web/config/excel/import/template/saveTemplate', this.templateConfig)
        .then(res => {
          this.$message.success(this.$t('success'));
          this.yt.get(1);
          this.yt.isShowEditDialog = false;
          this.templateConfig = JSON.parse(JSON.stringify(this.initTempletConfig));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },

    close() {
      this.yt.isShowEditDialog = false;
      this.templateConfig = JSON.parse(JSON.stringify(this.initTempletConfig));
    },

    beforeShow(params) {
      this.templateConfig = params;
      this.templateConfig.templateValue = JSON.parse(params.templateValue);
      return params;
    },

    update() {
      if (this.templateConfig.templateValue.length === 0) {
        this.$message.error(this.$t('mubanpeizhibunengweikong'));
        return;
      }
      this.http
        .post('/web/config/excel/import/template/saveTemplate', this.templateConfig)
        .then(res => {
          this.$message.success(this.$t('success'));
          this.yt.get(1);
          this.yt.isShowEditDialog = false;
          this.templateConfig = JSON.parse(JSON.stringify(this.initTempletConfig));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    }
  }
};
</script>
